import React, { useCallback, useEffect, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { ehandoverAPI } from '../../../../../apis/index.js';
import { getRoleTypeColor, revampTemplateData } from '../../../../../utils/eHandoverUtil.js';
import TemplateList from './TemplateList';
import EditTemplate from './EditTemplate/index.js';

const useStyles = makeStyles(() => ({
  root: {
    background: '#fff',
    padding: '1.875rem',
    borderRadius: '0 0.93rem 0.93rem 0.93rem',
  },
  container: {
    backgroundColor: '#EEF2F9',
    padding: '1.428rem',
    borderRadius: '0.857rem',
  },
  title: {
    fontSize: '1.714rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 700,
    marginBottom: '0.857rem',
  },
  subTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.142rem',
    fontWeight: 500,
    color: '#7D86A9',
    marginBottom: '1.428rem',
  },
  templateBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '1.25rem',
  },
}));

export default function ContentTemplate() {
  const classes = useStyles();
  const [templateList, setTemplateList] = useState([]);
  const [editTemplate, setEditTemplate] = useState(null);
  const loginInfo = useSelector((state) => state.loginInfo);
  const [individualUsers, setIndividualUsers] = useState([]);
  const [tagOptionList, setTagOptionList] = useState([]);
  // 初始化的checklist item
  const initCheckListItem = {
    isComplete: 'N',
    parentId: 0,
    sortIndex: 0,
    title: '',
  };
  // 初始化的template
  const [initTemplate, setInitTemplate] = useState({
    id: null,
    templateId: null,
    templateName: '',
    requiredAcknowLedge: false,
    title: '',
    description: '',
    checkLists: [],
    checklistComplete: false,
    itemComplete: false,
    notifyBaseOnSendTo: true,
    notifyList: {
      roomTypeList: [],
      staffList: [],
    },
    sendToList: {
      roomTypeList: [],
      staffList: [],
    },
    tags: [],
  });

  const getIndividualUserList = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getIndividualUserList();
      const newRoomTypeList = _.map(result?.roomTypeList ?? [], (roomItem) => ({
        ...roomItem,
        color: roomItem?.role ? getRoleTypeColor(roomItem?.role ?? '') : 'unset',
      }));
      const newStaffList = _.map(result?.staffList ?? [], (roomItem) => ({
        ...roomItem,
        color: getRoleTypeColor(roomItem?.role ?? ''),
      }));
      const defaultRoomType = _.find(result?.roomTypeList, (item) => item?.value === 1);
      setInitTemplate((prev) => ({
        ...prev,
        sendToList: {
          roomTypeList: defaultRoomType ? [defaultRoomType] : [],
          staffList: [],
        },
        notifyList: {
          roomTypeList: defaultRoomType ? [defaultRoomType] : [],
          staffList: [],
        },
      }));
      setIndividualUsers({ roomTypeList: newRoomTypeList, staffList: newStaffList });

      await getTaskTemplateList({ roomTypeList: newRoomTypeList, staffList: newStaffList });
    } catch (error) {}
  }, []);
  const getTagList = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getTagList();
      let newList = [];
      if (Array.isArray(result) && result.length > 0) {
        newList = _.map(result, (item) => {
          return {
            ...item,
            text: item.tagDesc,
            value: item?.id,
          };
        });
      }
      setTagOptionList(newList);
    } catch (error) {}
  }, []);

  const getTaskTemplateList = async (individualUsers) => {
    try {
      const { result } = await ehandoverAPI.getTaskTemplate();
      const templateList = result?.tasks ?? [];
      const taskIds = _.map(templateList, (taskItem) => taskItem?.id);

      // 根据所有template的taskId获取所有task里面的checklist
      const { result: checkListResult } = await ehandoverAPI.getNewTaskItemList(
        {
          order: { ID: 'asc', TOGGLED_DATE: 'asc', IS_COMPLETE: 'desc', SORT_INDEX: 'asc' },
          taskIdList: taskIds,
        },
        { isHideLoading: true }
      );

      const checkListGroupByTaskId = checkListResult.reduce((acc, item) => {
        const key = item.TASK_ID;
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, {});
      const newTemplateList = _.map(templateList, (item) => {
        return revampTemplateData({
          templateItem: item,
          checkListGroup: checkListGroupByTaskId,
          individualUsers,
        });
      });
      setTemplateList(newTemplateList);
    } catch (error) {}
  };

  useEffect(() => {
    if (loginInfo?.flag) {
      getIndividualUserList();
    }
    getTagList();
  }, [loginInfo?.flag, loginInfo?.wardId]);

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        {editTemplate ? (
          <EditTemplate
            templateInfo={editTemplate}
            setEditTemplate={setEditTemplate}
            individualUserOptions={individualUsers}
            tagOptionList={tagOptionList}
            initCheckListItem={initCheckListItem}
            getTaskTemplateList={getTaskTemplateList}
          />
        ) : (
          <TemplateList templateList={templateList} setEditTemplate={setEditTemplate} initTemplate={initTemplate} />
        )}
      </Box>
    </Box>
  );
}
